import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Global } from '../classes/Global';
import { Config } from '../classes/Config';
import { StringHelper } from '../helpers/StringHelper';
import { BaseComponent } from '../classes/BaseComponent';
import { ListHelper } from '../helpers/ListHelper';
import { LoginHelper } from '../helpers/LoginHelper';
import { StorageHelper } from '../helpers/StorageHelper';

@Component({
  selector: 'app-other-seasons',
  templateUrl: './other-seasons.component.html',
  styleUrls: ['./other-seasons.component.scss']
})
export class OtherSeasonsComponent extends BaseComponent implements OnInit, OnChanges {

  @Input() items;
  @Output() itemClicked = new EventEmitter();
  @Output() onWishlistAction = new EventEmitter<{ item: any, action: 'add' | 'remove' }>();
  @Output() onOwnlistAction = new EventEmitter<{ item: any, action: 'add' | 'remove' }>();

  constructor() {
    super();
  }

  ngOnInit() {
    this.updateAllListStates();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items && changes.items.currentValue) {
      this.updateAllListStates();
    }
  }

  /** Updates list states for all items - call this when items array changes */
  updateAllListStates(): void {
    if (!this.items) {
      return;
    }
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];
      if (item) {
        item._inWishlist = ListHelper.isItemInWishlist(item);
        item._inOwnlist = ListHelper.isItemInOwnlist(item);
      }
    }
  }

  isLoggedIn(): boolean {
    return StorageHelper.getInstance().get(StorageHelper.keys.sessionToken) != null;
  }

  toggleWishlist(e: Event, item: any): void {
    e.preventDefault();
    e.stopPropagation();
    if (!this.isLoggedIn()) {
      LoginHelper.getInstance().requestLogin();
      return;
    }
    const action = item._inWishlist ? 'remove' : 'add';
    item._inWishlist = !item._inWishlist; // Optimistic UI update
    this.onWishlistAction.emit({ item: item, action: action });
  }

  toggleOwnlist(e: Event, item: any): void {
    e.preventDefault();
    e.stopPropagation();
    if (!this.isLoggedIn()) {
      LoginHelper.getInstance().requestLogin();
      return;
    }
    const action = item._inOwnlist ? 'remove' : 'add';
    item._inOwnlist = !item._inOwnlist; // Optimistic UI update
    this.onOwnlistAction.emit({ item: item, action: action });
  }

  /** @deprecated Use item._inWishlist property instead for template bindings */
  isInWishlist(item: any): boolean {
    return item ? item._inWishlist : false;
  }

  /** @deprecated Use item._inOwnlist property instead for template bindings */
  isInOwnlist(item: any): boolean {
    return item ? item._inOwnlist : false;
  }

  getSeasonsNumberString(title: string): string {
    //Get the part after the comma
    const lastComma: number = title.lastIndexOf(',');
    if (lastComma > 0) {
      return title.substring(lastComma + 1).trim();
    }
    else {
      return "";
    }
  }

  getImageUrl(item): string {
    const id = item.idInStore || item.itemID;
    if (id) {
      return Config.imageServerUrl + Global.getCountry() + "/" + id + "/250x250.jpg";
    }
    return "";
  }

  getDetailViewUrl(item): string {
    if (!item) {
      return "";
    }

    const id = item.idInStore || item.itemID;
    if (!id) {
      return "";
    }

    const country = Global.getCountry();
    const storeUrl = Global.getStoreUrl();
    const mediaType = Global.getMediaTypeForDetailView();
    const title = item.title;

    if (!country || !storeUrl || !mediaType || !title) {
      return "";
    }

    return '/' + country + '/' + storeUrl + '/' + mediaType + '/' + id + '/' + StringHelper.slugify(title);
  }

}
